// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Comment\ApiComment.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { CoordinationCardSelf, CoordinationCardSelfData, CoordinationCardSelfOptions } from 'data/models/CoordinationCardSelf';
import { Event, EventData, EventOptions } from 'data/models/Event';
import { JobOrderSelf, JobOrderSelfData, JobOrderSelfOptions } from 'data/models/JobOrderSelf';
import { PortCallSelf, PortCallSelfData, PortCallSelfOptions } from 'data/models/PortCallSelf';
import { TaggedCommentUser, TaggedCommentUserData, TaggedCommentUserOptions } from 'data/models/TaggedCommentUser';
import { TopicCard, TopicCardData, TopicCardOptions } from 'data/models/TopicCard';

// CommentData is the class that Comment serializes to/from
export interface CommentData {
    Id : number;
	
    AttachmentUrl : string | null;
    Event : EventData | null;
    EventId : number;
    SubjectCoordinationCard : CoordinationCardSelfData | null;
    SubjectCoordinationCardId : number | null;
    SubjectEvent : EventData | null;
    SubjectEventId : number | null;
    SubjectJobOrder : JobOrderSelfData | null;
    SubjectJobOrderId : number | null;
    SubjectPortCall : PortCallSelfData | null;
    SubjectPortCallId : number | null;
    SubjectTopicCard : TopicCardData | null;
    SubjectTopicCardId : number | null;
    TaggedUsers : TaggedCommentUserData[] | null;
	
    Message : string | null;
}

// CommentOptions is the class which may be passed to the Comment constructor to define optional initial data values
export interface CommentOptions {
    Id : number;
	
    AttachmentUrl? : string | null;
    Event? : EventOptions | null;
    EventId? : number;
    SubjectCoordinationCard? : CoordinationCardSelfOptions | null;
    SubjectCoordinationCardId? : number | null;
    SubjectEvent? : EventOptions | null;
    SubjectEventId? : number | null;
    SubjectJobOrder? : JobOrderSelfOptions | null;
    SubjectJobOrderId? : number | null;
    SubjectPortCall? : PortCallSelfOptions | null;
    SubjectPortCallId? : number | null;
    SubjectTopicCard? : TopicCardOptions | null;
    SubjectTopicCardId? : number | null;
    TaggedUsers? : TaggedCommentUserOptions[] | null;
	
    Message? : string | null;
}

export class Comment {
    public Id : DataSignal<number>;
	
    public AttachmentUrl : DataSignal<string | null>;
    public Event : DataSignal<Event | null>;
    public EventId : DataSignal<number>;
    public SubjectCoordinationCard : DataSignal<CoordinationCardSelf | null>;
    public SubjectCoordinationCardId : DataSignal<number | null>;
    public SubjectEvent : DataSignal<Event | null>;
    public SubjectEventId : DataSignal<number | null>;
    public SubjectJobOrder : DataSignal<JobOrderSelf | null>;
    public SubjectJobOrderId : DataSignal<number | null>;
    public SubjectPortCall : DataSignal<PortCallSelf | null>;
    public SubjectPortCallId : DataSignal<number | null>;
    public SubjectTopicCard : DataSignal<TopicCard | null>;
    public SubjectTopicCardId : DataSignal<number | null>;
    public TaggedUsers : SDataArray<TaggedCommentUser>;
	
    public Message : DataSignal<string | null>;

    constructor();
    constructor(data : CommentOptions);
    constructor(data: CommentOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.AttachmentUrl = jsonableObservable(S.value<string | null>(data && data.AttachmentUrl !== undefined ? data.AttachmentUrl : null));
        this.Event = S.value<Event | null>(null);
        this.EventId = jsonableObservable(S.value<number>(data && data.EventId !== undefined ? data.EventId : 0));
        this.SubjectCoordinationCard = S.value<CoordinationCardSelf | null>(null);
        this.SubjectCoordinationCardId = jsonableObservable(S.value<number | null>(data && data.SubjectCoordinationCardId !== undefined ? data.SubjectCoordinationCardId : null));
        this.SubjectEvent = S.value<Event | null>(null);
        this.SubjectEventId = jsonableObservable(S.value<number | null>(data && data.SubjectEventId !== undefined ? data.SubjectEventId : null));
        this.SubjectJobOrder = S.value<JobOrderSelf | null>(null);
        this.SubjectJobOrderId = jsonableObservable(S.value<number | null>(data && data.SubjectJobOrderId !== undefined ? data.SubjectJobOrderId : null));
        this.SubjectPortCall = S.value<PortCallSelf | null>(null);
        this.SubjectPortCallId = jsonableObservable(S.value<number | null>(data && data.SubjectPortCallId !== undefined ? data.SubjectPortCallId : null));
        this.SubjectTopicCard = S.value<TopicCard | null>(null);
        this.SubjectTopicCardId = jsonableObservable(S.value<number | null>(data && data.SubjectTopicCardId !== undefined ? data.SubjectTopicCardId : null));
        this.TaggedUsers = SArray<TaggedCommentUser>([]);
	    
        this.Message = jsonableObservable(S.value<string | null>(data && data.Message !== undefined ? data.Message : null));
    }

    static key(obj : Comment) {
        return obj.Id();
    }
    
    static dataKey(obj : CommentOptions) {
        return obj.Id;
    }

    static update(obj : Comment, data : CommentOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.AttachmentUrl !== undefined) obj.AttachmentUrl(data.AttachmentUrl);
            if (data.EventId !== undefined) obj.EventId(data.EventId);
            if (data.SubjectCoordinationCardId !== undefined) obj.SubjectCoordinationCardId(data.SubjectCoordinationCardId);
            if (data.SubjectEventId !== undefined) obj.SubjectEventId(data.SubjectEventId);
            if (data.SubjectJobOrderId !== undefined) obj.SubjectJobOrderId(data.SubjectJobOrderId);
            if (data.SubjectPortCallId !== undefined) obj.SubjectPortCallId(data.SubjectPortCallId);
            if (data.SubjectTopicCardId !== undefined) obj.SubjectTopicCardId(data.SubjectTopicCardId);
	        
            if (data.Message !== undefined) obj.Message(data.Message);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Comment.ts